import React from 'react';
import SurfParagraphSelectBar from './SurfParagraphSelectBar';
import SurfImageSelectBar from './SurfImageSelectBar';
import webapi from '../../../api/webapi';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import '../../css/react-tabs2.css';
import Loading from '../modal/Loading';



class SurfSearchBox extends React.Component {
    constructor(props) {
        super(props);
    
        this.state = { books: [] };
        this.state = { chapters: [] };
        this.state = { SelectedBookGroup: '' };
        this.state = { SelectedBook: '' };
        this.state = { SelectedChapter: '' };
        this.state = { PicLoadingQueue : 0 };
    }

    componentDidMount() {
        this.setState({LoadingShow:true})
        this.setState({ SelectedBook: '' });
        this.setState({ SelectedChapter: '' });

        this.GetBookGroups();

        this.setState({LoadingShow:false})
    };

    GetBookGroups = async () =>{
        await webapi.get('surf/allbookgroups/'+this.props.Lang)
            .then(response => {
                this.setState({ BookGroups: response.data},() => {} );
            })
        if (this.state.BookGroups!==undefined)
        {
            this.setState({ SelectedBookGroup : this.state.BookGroups[0].Code},() => {} );
            this.GetBooks(this.state.BookGroups[0].Code)
        }
        else
        {
            this.setState({SelectedBook : ''})
            this.setState({SelectedChapter : ''})
        }
    }

    GetBooks = async BookGroupCode =>{
        this.setState({LoadingShow:true})
        await webapi.get('surf/bookgroupsbook/'+BookGroupCode+'/'+this.props.Lang)
            .then(response => {
                this.setState({ books: response.data });
            })
       if (this.state.books!==undefined)
       {
           this.setState({ SelectedBook : this.state.books[0].Code },() => {} )
           this.GetChapters(this.state.books[0].Code)
        }
        else
        {
            this.setState({SelectedBook : ''})
            this.setState({SelectedChapter : ''})
        }                
    }

    GetChapters = async BookCode =>{
        this.setState({LoadingShow:true})
        await webapi.get('surf/bookschapter/'+ BookCode+'/'+this.props.Lang)
            .then(response => {
                this.setState({ chapters: response.data });
            })
       if (this.state.chapters!==undefined)
       {
           this.setState({ SelectedChapter : this.state.chapters[0].Code })
       }
       this.setState({LoadingShow:false})        
    }

    onChangeBookGroupSelect = async event => {
        this.setState({LoadingShow:true})
        this.setState({ SelectedBookGroup: event.target.value});
        
        this.GetBooks(event.target.value);
    };

    onChangeBookSelect = async event => {
        this.setState({LoadingShow:true})
        this.setState({ SelectedBook: event.target.value},()=>{});
        
        this.GetChapters( event.target.value );
    };

    onChangeChapterSelect = async event => {
        this.setState({ SelectedChapter:event.target.value }, () => {})
    };

    onSelectTab = (tabIndex)=>{
        this.setState({ tabIndex : tabIndex});
        this.props.onSelectTab(tabIndex);
    }

    render() {
        return (
            [
                <div className="container-fluid" id="words_search_form">
                    <div className="container">
                        <br />
                        <div className="select_param">           
                            <label>{this.props.pageData.length!==0 && this.props.pageData[0].F20101!== undefined?this.props.pageData[0].F20101:20101/*نوع متن*/}</label>
                            <select className="" id='select' onChange={this.onChangeBookGroupSelect}>
                                {   this.state.BookGroups != null 
                                    ?
                                    (   
                                        this.state.BookGroups.map((bookgroup) =>{
                                            return  (
                                                <option key={bookgroup.Code} value={bookgroup.Code}>{bookgroup.Title}</option> 
                                            )
                                        })
                                    )
                                    :
                                    <option key="-1">-</option>       
                                }
                            </select>
                        </div>
                        <div className="select_param">           
                            { 
                                (this.state.SelectedBookGroup==="2")
                                ?
                                <label>{this.props.pageData.length!==0 && this.props.pageData[0].F20106!== undefined?this.props.pageData[0].F20106:20106/*نوع کتیبه*/}</label>
                                :
                                <label>{this.props.pageData.length!==0 && this.props.pageData[0].F20102!== undefined?this.props.pageData[0].F20102:20102/*نام متن*/}</label>
                            }
                            <select onChange={this.onChangeBookSelect} className="">
                                {   this.state.books != null 
                                    ?
                                    (   
                                        this.state.books.map((book) =>{
                                            return  (
                                                <option key={book.Code} value={book.Code}>{book.Title}</option> 
                                            )
                                        })
                                    )
                                    :
                                    <option key="-1">-</option>       
                                }
                            </select>
                        </div>
                        <div className="select_param">           
                            { 
                                (this.state.SelectedBookGroup==="2")
                                ?
                                <label>{this.props.pageData.length!==0 && this.props.pageData[0].F20107!== undefined?this.props.pageData[0].F20107:20107/*نام کتیبه*/}</label>
                                :
                                <label>{this.props.pageData.length!==0 && this.props.pageData[0].F20103!== undefined?this.props.pageData[0].F20103:20103/*شماره فصل*/}</label>
                            }
                            <select onChange={this.onChangeChapterSelect}  className="">
                                {   this.state.chapters != null 
                                    ?
                                    (   this.state.chapters.map((chapter,i) =>{
                                            return  (
                                                (this.state.chapters.length>1 && i===0)
                                                ?
                                                (
                                                    [
                                                        <option key={i+'j'+chapter.Code} value={chapter.Code}>{chapter.Title}</option> 
                                                    ]
                                                )
                                                :
                                                (
                                                    <option key={i+'k'+chapter.Code} value={chapter.Code}>{chapter.Title}</option> 
                                                )
                                            )
                                        })
                                    )
                                    :
                                    <option key="-1">{this.props.pageData.length!==0 && this.props.pageData[0].F29902!== undefined?this.props.pageData[0].F29902:29902/*همه*/}</option>       
                                }
                            </select>
                        </div>
                        <br />
                        <Tabs   className ="search-tab" 
                                selectedTabPanelClassName="search_tab-panel--selected" 
                                selectedTabClassName="search_tab--selected"
                                disabledTabClassName="search_tab--disabled"
                                selectedIndex={this.props.tabIndex} 
                                onSelect={tabIndex => this.setState({ tabIndex })}//onSelect={(tabIndex ) => this.onSelectTab(tabIndex)} 
                        >
                            <TabList className="search-tab-list">
                                <Tab className ="search_tab">{this.props.pageData.length!==0 && this.props.pageData[0].F20104!== undefined?this.props.pageData[0].F20104:20104/*آوانویسی و ترجمه*/}</Tab>
                                <Tab className ="search_tab">{this.props.pageData.length!==0 && this.props.pageData[0].F20105!== undefined?this.props.pageData[0].F20105:20205/*متن پهلوی*/}</Tab>
                            </TabList>

                            <TabPanel className ="search_tab-panel">
                                <SurfParagraphSelectBar     key={this.state.SelectedChapter}
                                                            SelectedBook={this.state.SelectedBook}
                                                            SelectedChapter={this.state.SelectedChapter}
                                                            pageData={this.props.pageData}
                                />
                            </TabPanel>
                            <TabPanel className ="search_tab-panel">
                                <SurfImageSelectBar     key={this.state.SelectedChapter+"1"}
                                                        SelectedBook={this.state.SelectedBook}
                                                        SelectedChapter={this.state.SelectedChapter}
                                                        pageData={this.props.pageData}

                                />                            
                            </TabPanel>
                        </Tabs>
                    </div>
                </div>
                ,
                <Loading LoadingShow={this.state.LoadingShow} />
            ]
        )
    }
}

export default SurfSearchBox;